import {useState} from 'react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import styles from './Dashboard.module.scss';
import { DownloadUsageReportData } from '../../api-services/common.api';

interface IFormInit {
  startDate: Date | null,
  endDate: Date | null,
}

const UsageReport  =  () => {
  const [form, setForm] = useState<IFormInit>({ startDate: null, endDate: null });
  const downloadBtnValidity = (): boolean => !!form.startDate && !!form.endDate;

  const downloadUsageReport=()=>{
    const params = {
      userId: sessionStorage.getItem('userName'),
      startDate: !!form.startDate
        ? [form.startDate.getFullYear(), ('0' + (form.startDate.getMonth() + 1)).slice(-2),('0' + form.startDate.getDate()).slice(-2)].join('')
        : null,
      endDate: !!form.endDate
        ? [form.endDate.getFullYear(), ('0' + (form.endDate.getMonth() + 1)).slice(-2),('0' + form.endDate.getDate()).slice(-2)].join('')
        : null,
    };

    DownloadUsageReportData(params)
    .then((response) => {
      if (!!response) {
          response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = "Usage_Report.xlsx";
          a.click();
        });
      }else{
        alert('Error while downloading Report.');
      }
    });
  }
  

  return (
    <div className={styles['usageDownload']}>
      {(
        <div className={styles['usageDownloadDiv']}>
          <table>
            <thead className={styles['usageDownloadTHead']}>Download Usage Report</thead>
           <tbody>
            <tr>
            <td><br/><br/>
            <label className="font-size-14 form-label-text me-2">Start Date:</label>
              <DatePicker
              className="form-input-field"
                selected={form.startDate}
                onChange={(date: Date) => setForm({ ...form, startDate: date })}
                selectsStart
                startDate={form.startDate}
                endDate={form.endDate}
                placeholderText="DD-MM-YYYY"
                dateFormat="dd-MM-yyyy"
              />
            </td>
            <td><br/><br/>
            <label className="font-size-14 form-label-text me-2">End Date:</label>
              <DatePicker
              className="form-input-field"
                selected={form.endDate}
                onChange={(date: any) => setForm({ ...form, endDate: date })}
                selectsEnd
                startDate={form.startDate}
                endDate={form.endDate}
                minDate={form.startDate}
                placeholderText="DD-MM-YYYY"
                dateFormat="dd-MM-yyyy"
              />
            </td>
            </tr>
            </tbody> 
            <tfoot><br></br><br></br>
            <div>
            <button color={'primary'}
                className="btn btn-sm btn-primary ms-3 mx-3"
                disabled={!downloadBtnValidity()}
                onClick={()=> downloadUsageReport()}
                > 
                  Dowload
                </button>
            </div>
            
            </tfoot>
          </table>
          </div>    
          
      )}
      
    </div>
    
  );
};

// Basic inline styles for the popup box and content


export default UsageReport;


